import SimpleType from "sap/ui/model/SimpleType";
import ValidateException from "sap/ui/model/ValidateException";

export interface RegexConstraints {
	pattern?: string;
}

export default class RegexType extends SimpleType {
	private _pattern: RegExp;

	constructor(oFormatOptions?: object, oConstraints?: RegexConstraints) {
		super(oFormatOptions, oConstraints);
		const regexString = oConstraints?.pattern ?? ".*";
		this._pattern = new RegExp(regexString);
	}

	// View value -> Model value
	parseValue(oValue: any, _sInternalType: string): any {
		return oValue;
	}

	// Model value -> View value
	formatValue(oValue: any, _sInternalType: string): any {
		return oValue;
	}

	// Validation step
	validateValue(oValue: any): void {
		if (typeof oValue !== "string" || !this._pattern.test(oValue)) {
			throw new ValidateException(
				`Invalid value '${oValue}', must match pattern: ${this._pattern}`,
			);
		}
	}
}
